import { render, staticRenderFns } from "./LawList.vue?vue&type=template&id=7ab62719&scoped=true"
import script from "./LawList.vue?vue&type=script&lang=js"
export * from "./LawList.vue?vue&type=script&lang=js"
import style0 from "./LawList.vue?vue&type=style&index=0&id=7ab62719&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab62719",
  null
  
)

export default component.exports